import React from "react";
import {ChipLabel} from "./index";

const PrivateWealthWarningChip = ({type}) => {
    const typeData = {
        "former_member_warning": {
            class: "status-chip create",
            text: "Former Member"
        },
        "member_warning": {
            class: "status-chip create",
            text: "Member"
        },
        "aum_warning": {
            class: "status-chip primary",
            text: "AUM"
        },
        "location_warning": {
            class: "status-chip secondary",
            text: "Location"
        },
        "parent_movement": {
            class: "status-chip secondary",
            text: "Parent Movement"
        },
        "missing_location_warning": {
            class: "status-chip secondary",
            text: "Missing Location"
        },
        "potential_dup_warning": {
            class: "status-chip adoption",
            text: "Dup"
        },
        "pending": {
            class: "status-chip warning",
            text: "Pending"
        },
        "resolved": {
            class: "status-chip success",
            text: "Resolved"
        },
        "ignored": {
            class: "status-chip default",
            text: "Ignored"
        },
        "url_warning": {
            class: "status-chip error",
            text: "URL"
        },
        "potential_ria": {
            class: "status-chip secondary",
            text: "Potential RIA"
        },
        "allowed_domain": {
            class: "status-chip secondary",
            text: "Domain is not allowed"
        },
    }

    return (<ChipLabel label={typeData[type]?.text} className={typeData[type]?.class}/>)
}

export default PrivateWealthWarningChip;
